import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import classnames from 'classnames';
import * as propTypes from '../propTypes';
import config from '../../../../../config';

const Day = ({ day, selected }) => {
  const dayOfWeek = moment(day).format('ddd');
  const dateFormat = moment(day).format('DD');

  const dowClassName = classnames('u-type--bold', { 'c-heading--lightgrey': !selected });
  const dayClassName = classnames({
    'c-appointment-details-day-number': !selected,
    'c-round-number u-color-primary': selected,
  });

  return (
    <div className="c-heading u-inline-block u-fontsize-extrasmall">
      <span className={dowClassName}>{dayOfWeek}</span><br />
      <div className={dayClassName}>{dateFormat}</div>
    </div>
  );
};
Day.propTypes = {
  day: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

const Days = ({ selected, days, selectDay, loading }) => (
  <div className="o-tableize u-table-layout-fixed u-text-center u-type--uppercase">
    <div className="o-tableize__row u-color-grey-lighten-1">
      { days.map(({ day, available }, index) => (
        <div
          key={index}
          data-automation-id={moment(day).format(config.dateFormatISO)}
          className={
            `c-appointment-details-day o-tableize__cell u-pv-- ${!available ? 'u-color-grey-lighten-2' : ''}`
          }
          onClick={() => !loading && selectDay(day)}
        >
          <Day day={day} selectDay={selectDay} selected={day === selected} />
        </div>
      )) }
    </div>
  </div>
);
Days.propTypes = {
  days: propTypes.days,
  selected: PropTypes.string,
  selectDay: PropTypes.func,
  loading: PropTypes.bool,
};

export default Days;
